import {
  AttendanceCheckMonthParticipateResponseDto,
  AttendanceCheckMonthsResponseDto,
  AttendanceCheckNotiResponseDto,
  AttendanceChecksResponseDto,
} from '@diritto/common/activityPoint/dtos/attendance-check.dtos';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { generateUrl } from '@diritto/common/utils/urls';
import { AxiosRequestConfig } from 'axios';

export class AttendanceCheckApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async participate(attendanceCheckMonthId: number, options?: AxiosRequestConfig) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/activity-points/attendance-check/months/${attendanceCheckMonthId}/participate`,
      undefined,
      options,
    );
    return res.data;
  }

  async attend(options?: AxiosRequestConfig) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/activity-points/attendance-check`,
      undefined,
      options,
    );
    return res.data;
  }

  async getParticipate(attendanceCheckMonthId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<AttendanceCheckMonthParticipateResponseDto>(
      `${this.url}/activity-points/attendance-check/months/${attendanceCheckMonthId}/participate`,
      options,
    );
    return res.data;
  }

  async findAttend(yearMonth: string, options?: AxiosRequestConfig) {
    const res = await this.http.get<AttendanceChecksResponseDto>(
      generateUrl(`${this.url}/activity-points/attendance-check/monthly`, {
        yearMonth,
      }),
      options,
    );
    return res.data;
  }

  async findMonths(options?: AxiosRequestConfig) {
    const res = await this.http.get<AttendanceCheckMonthsResponseDto>(
      `${this.url}/activity-points/attendance-check/months`,
      options,
    );
    return res.data;
  }

  async getNoti(options?: AxiosRequestConfig) {
    const res = await this.http.get<AttendanceCheckNotiResponseDto>(
      `${this.url}/activity-points/attendance-check/noti`,
      options,
    );
    return res.data;
  }

  async addNoti(options?: AxiosRequestConfig) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/activity-points/attendance-check/noti`,
      undefined,
      options,
    );
    return res.data;
  }

  async deleteNoti(options?: AxiosRequestConfig) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/activity-points/attendance-check/noti`, options);
    return res.data;
  }
}
